import { useMemo } from 'react';
import { Avatar, Tooltip } from 'antd';
import dayjs from 'dayjs';
import { DateType } from '../types/common';

export const useUserDateRender = (dateType: DateType) => {
  return useMemo(
    () => (dateValue: any, record: any) => {
      if (!dateValue) return '';

      const date = dayjs(dateValue);
      const isToday = date.isSame(dayjs(), 'day');
      const isYesterday = date.isSame(dayjs().subtract(1, 'day'), 'day');
      const isThisYear = date.isSame(dayjs(), 'year');

      let displayDate;
      if (isToday) {
        displayDate = 'Today';
      } else if (isYesterday) {
        displayDate = 'Yesterday';
      } else if (isThisYear) {
        displayDate = date.format('MMM DD');
      } else {
        displayDate = date.format('MMM DD, YYYY');
      }

      const timeAgo = date.fromNow();
      const userName =
        dateType === 'created'
          ? record.created_by_name || `User ${record.created_by || 'N/A'}`
          : record.updated_by_name || `User ${record.updated_by || 'N/A'}`;

      const avatarText =
        dateType === 'created'
          ? record.created_by_name
            ? record.created_by_name.charAt(0).toUpperCase()
            : 'U'
          : record.updated_by_name
          ? record.updated_by_name.charAt(0).toUpperCase()
          : 'U';

      const avatarColor = dateType === 'created' ? '#1890ff' : '#52c41a';

      return (
        <Tooltip
          title={`${date.format(
            'MMM DD, YYYY HH:mm'
          )} (${timeAgo}) by ${userName}`}
          placement="top"
        >
          <div
            style={{
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
            }}
          >
            <Avatar
              size="small"
              style={{
                backgroundColor: avatarColor,
                flexShrink: 0,
              }}
            >
              {avatarText}
            </Avatar>
            <div>
              <div
                style={{
                  fontWeight: 500,
                  color: '#262626',
                  fontSize: '13px',
                }}
              >
                {displayDate}
              </div>
              <div style={{ fontSize: '11px', color: '#8c8c8c' }}>
                {timeAgo}
              </div>
            </div>
          </div>
        </Tooltip>
      );
    },
    [dateType]
  );
};
